
import { Link } from "react-router-dom";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { urlFor } from "@/integrations/sanity/client";
import { formatDistanceToNow } from "date-fns";

interface BlogCardProps {
  post: {
    _id: string;
    title: string;
    slug: { current: string };
    excerpt?: string;
    mainImage?: any;
    publishedAt: string;
    category?: string;
    tags?: string[];
    author?: string;
  };
}

export function BlogCard({ post }: BlogCardProps) {
  return (
    <Link to={`/blog/${post.slug.current}`}>
      <Card className="h-full overflow-hidden hover:shadow-md transition-shadow duration-300">
        {post.mainImage && (
          <div className="aspect-video w-full overflow-hidden">
            <img 
              src={urlFor(post.mainImage).width(600).url()} 
              alt={post.title}
              className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
            />
          </div>
        )}
        <CardHeader className="pb-2">
          <h3 className="text-xl font-semibold line-clamp-2">{post.title}</h3>
          {post.category && (
            <Badge variant="secondary" className="text-xs mr-2">
              {post.category}
            </Badge>
          )}
        </CardHeader>
        
        <CardContent>
          {post.excerpt && (
            <p className="text-muted-foreground line-clamp-3">
              {post.excerpt}
            </p>
          )}
        </CardContent>
        
        <CardFooter className="text-sm text-muted-foreground flex justify-between">
          {post.author && <span>{post.author}</span>}
          {post.publishedAt && (
            <time dateTime={post.publishedAt}>
              {formatDistanceToNow(new Date(post.publishedAt), { addSuffix: true })}
            </time>
          )}
        </CardFooter>
      </Card>
    </Link>
  );
}
